// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { addNewItemsStyles } from "@sc/App/Components/MyListsDetails/AddNewItems";
import { css } from "styled-components";

addNewItemsStyles.orderUploadGridItem = {
    width: [12, 12, 6, 6, 6],
};
addNewItemsStyles.uploadInstructionsGridItem = {
    width: [12, 12, 6, 6, 6],
};
addNewItemsStyles.actionButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
    `,
};
addNewItemsStyles.productSelectorModal = {
    sizeVariant: "medium",
};
addNewItemsStyles.actionsWrapper = {
    css: css`
        display: flex;
        margin-top: 20px;
        justify-content: end;
        gap: 15px;
    `,
};

addNewItemsStyles.productSelectorStyles = {
    selectButton: {
        css: css`
            min-height: 36px;
        `,
    },
    buttonGridItem: {
        css: css`
            &&& {
                margin-top: 18px;
            }
        `,
    },
};
